/**
 * This enum is used to define the model used by the chatbot.
 *
 * @author Mc Ayrton Aragon
 */
export enum OpenAIChatbotModelEnum {
  LOCAL = 'LOCAL',
  OPENAI = 'OPENAI'
}
